(() => {
  const root = document.querySelector('product-info');
  if (!root) return;

  const now = Date.now();

  const applyTimer = (suffix) => {
    const startRaw = root.dataset[`displayTimerStart${suffix}`]; // '' / undefined / 文字列
    const endRaw   = root.dataset[`displayTimerEnd${suffix}`];

    const className = suffix ? `.display-timer${suffix}` : '.display-timer';
    const targets = document.querySelectorAll(className);

    // 両方未設定 → 常に非表示
    if (!startRaw && !endRaw) {
      targets.forEach((el) => el.classList.remove('is-active'));
      return;
    }

    const start = startRaw ? Date.parse(startRaw) : null;
    const end   = endRaw ? Date.parse(endRaw) : null;

    let inRange = false;
    if (start !== null && end !== null) inRange = now >= start && now <= end;
    else if (start !== null) inRange = now >= start;
    else if (end !== null) inRange = now <= end;

    targets.forEach((el) => {
      el.classList.toggle('is-active', inRange);
    });
  };

  // suffix は「2」「3」。1枠目は空文字で既存通り
  applyTimer('');
  applyTimer('2');
  applyTimer('3');
})();
